import React, { Suspense, lazy } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ScrollToPosition from "./components/ScrollToPosition";
import Header from "./components/header/";
import Footer from "./components/footer/";
import { AuthProvider } from "./auth/AuthProvider";
import RequireRole from "./auth/RequireRole";
import "./App.css";

const Home = lazy(() => import("./pages/home"));
const Contact = lazy(() => import("./pages/home/contact"));
const Gallery = lazy(() => import("./pages/gallery"));
const Video = lazy(() => import("./pages/extras/"));
const Links = lazy(() => import("./pages/extras/links"));
const Membership = lazy(() => import("./pages/membership/"));
const Application = lazy(() => import("./pages/membership/application"));
const About = lazy(() => import("./pages/society/"));
const News = lazy(() => import("./pages/society/news"));
const CompetitionAbout = lazy(() => import("./pages/society/competition/"));
const Classes = lazy(() => import("./pages/society/competition/classes"));
const Scoring = lazy(() => import("./pages/society/competition/scoring"));
const Venues = lazy(() => import("./pages/society/competition/venues"));
const Results = lazy(() => import("./pages/society/competition/results"));
const NotFound = lazy(() => import("./pages/home/404"));

// Admin area: signing in, messages, and (admins only) user accounts.
const AdminLogin = lazy(() => import("./pages/admin/Login"));
const AdminLogout = lazy(() => import("./pages/admin/Logout"));
const AdminSetup = lazy(() => import("./pages/admin/Setup"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const AdminMessages = lazy(() => import("./pages/admin/Messages"));
const AdminUsers = lazy(() => import("./pages/admin/Users"));
const AdminChangePassword = lazy(() => import("./pages/admin/ChangePassword"));

function App() {
  return (
    <AuthProvider>
      <Header></Header>
      <ScrollToPosition>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route
              path="/Home/Contact"
              element={<Navigate to="/contact-us" replace />}
            />
            <Route
              path="/Home/TradeStands"
              element={<Navigate to="/contact-us" replace />}
            />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/videos" element={<Video />} />
            <Route
              path="/Gallery/Videos"
              element={<Navigate to="/videos" replace />}
            />
            <Route path="/links" element={<Links />} />
            <Route
              path="/Home/Links"
              element={<Navigate to="/links" replace />}
            />
            <Route path="/membership" element={<Membership />} />
            <Route
              path="/Society/Membership"
              element={<Navigate to="/membership/" replace />}
            />
            <Route path="/membership/application" element={<Application />} />
            <Route path="/society/" element={<About />} />
            <Route path="/society/news" element={<News />} />
            <Route
              path="News"
              element={<Navigate to="/society/news" replace />}
            />
            <Route
              path="/society/competition/"
              element={<CompetitionAbout />}
            />
            <Route
              path="Ploughing"
              element={<Navigate to="/society/competition/" replace />}
            />
            <Route path="/society/competition/classes" element={<Classes />} />
            <Route
              path="/Ploughing/Classes"
              element={<Navigate to="/society/competition/classes" replace />}
            />
            <Route path="/society/competition/scoring" element={<Scoring />} />
            <Route
              path="/Ploughing/Scoring"
              element={<Navigate to="/society/competition/scoring" replace />}
            />
            <Route path="/society/competition/venues" element={<Venues />} />
            <Route
              path="/History"
              element={<Navigate to="/society/competition/venues" replace />}
            />
            <Route path="/society/competition/results" element={<Results />} />
            <Route
              path="/History/Results"
              element={<Navigate to="/society/competition/results" replace />}
            />
            <Route
              path="/Home/CotswoldCartHorseSociety"
              element={<Navigate to="/" replace />}
            />
            <Route path="/Event" element={<Navigate to="/" replace />} />
            <Route
              path="Event/Timetable"
              element={<Navigate to="/" replace />}
            />
            <Route path="/Event/FAQ" element={<Navigate to="/" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/logout" element={<AdminLogout />} />
            <Route path="/admin/setup" element={<AdminSetup />} />
            <Route
              path="/admin"
              element={<RequireRole><AdminDashboard /></RequireRole>}
            />
            <Route
              path="/admin/messages"
              element={<RequireRole><AdminMessages /></RequireRole>}
            />
            <Route
              path="/admin/users"
              element={<RequireRole roles={["admin"]}><AdminUsers /></RequireRole>}
            />
            <Route
              path="/admin/password"
              element={<RequireRole><AdminChangePassword /></RequireRole>}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToPosition>
      <Footer></Footer>
    </AuthProvider>
  );
}

export default App;
